import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DropdownLegalForm, LegalFormDto } from '../interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sortBy } from 'underscore';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LegalFormsService {
  private iAdminURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iAdminURL = config.iAdminApiBaseURL;
  }

  fetchLegalForms(): Observable<LegalFormDto[]> {
    return this.http.get<LegalFormDto[]>(`${this.iAdminURL}/Global/FormesJuridiques`);
  }

  fetchMappedLegalFormsToPrimeNGDropdowns(): Observable<DropdownLegalForm[]> {
    return this.fetchLegalForms().pipe(
      map((res: LegalFormDto[]) => {
        let mappedLegalFormArray: DropdownLegalForm[] = [];

        res.forEach((legalForm: LegalFormDto) => {
          let mappedLegalForm: DropdownLegalForm = {} as DropdownLegalForm;
          mappedLegalForm = { ...legalForm, value: legalForm.id, label: legalForm.description };

          mappedLegalFormArray.push(mappedLegalForm);
        });

        mappedLegalFormArray = sortBy(mappedLegalFormArray, 'label');

        return mappedLegalFormArray;
      })
    );
  }
}
